import { createRoute, redirect } from '@tanstack/react-router';
import { Route as pathlessAuthenticatedRoute } from '../route';
import { NotificationsHistoryPage } from './NotificationsHistoryPage';

export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/notifications',
  component: NotificationsHistoryPage,
  // Notifications now live inside the Inbox; keep the legacy path working by
  // forwarding it to the Inbox's notifications filter.
  beforeLoad: () => {
    throw redirect({
      to: '/inbox',
      search: { tab: 'inbox', filter: 'notifications' },
    });
  },
  loader: () => ({
    crumb: 'Notifications',
  }),
});
